import DashboardBerthingManagementAPI from './dashboard-berthing-management.api'

export default DashboardBerthingManagementAPI